import "./Filters.css";

export default function Filters({
                                    date,
                                    setDate,
                                    status,
                                    setStatus,
                                }) {
    return (
        <div className="filters">
            <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
            >
                <option value="All">All</option>
                <option value="came on time">Came On Time</option>
                <option value="late">Late</option>
                <option value="left early">Left Early</option>
                <option value="left on time">Left On Time</option>
                <option value="absent">Absent</option>
            </select>

        </div>
    );
}
